<template>
  <div class="inner-tab-wrapper mb-4">
    <b-overlay center :show="isLoading" rounded="sm">
      <div style="display: flex; flex-direction: column; gap: 1.25rem" v-if="!isLoading">
        <div class="form-card-wrapper">
          <b-card header-tag="header">
            <div
              slot="header"
              class="d-flex justify-content-between align-items-center"
            >
              <p class="mb-0 d-inline-block align-middle">
                <b>Dati Principali</b>
              </p>
              <b-btn
                variant="lisaweb"
                class="btn-create btn--smaller"
                style="padding-left: 20px"
                size="sm"
                @click="migrate.click()"
                v-if="migrate.click"
              >
                {{ migrate.label }}
              </b-btn>
            </div>
            <div class="details-card custom-grid-wrapper">
              <div class="grid-item-label">
                <strong>Codice Produttore di Compagnia</strong>
              </div>
              <div class="grid-item-value">{{ dbRowData.map }}</div>
              <div class="grid-item-label"><strong>Compagnia</strong></div>
              <div class="grid-item-value">
                {{
                  dbRowData["insurer"] ? dbRowData.insurer.formatted_title : ""
                }}
              </div>
            </div>
          </b-card>
        </div>

        <div v-if="!dbRowData.mappable_id">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card
                  header-tag="header"
                  class="mt-1"
                >
                  <div
                    slot="header"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="mb-0 d-inline-block align-middle">
                      <b>Mappatura Produttori - associa produttore</b>
                    </p>
                  </div>
                  <b-card-text>
                    <div class="form-group col-md-8">
                      <base-select
                        name="salesmen"
                        vid="salesmen"
                        label="Produttori Lisaweb"
                        v-model="form.mappable_id"
                        :options="opt_salesmen"
                        :rules="{ required: true }"
                      />
                    </div>
                  </b-card-text>
                </b-card>
              </div>
              <div class="py-2 mb-4">
                <b-button
                  @click="handleSubmit(onUpdate)"
                  type="button"
                  :disabled="invalid"
                  variant="lisaweb"
                  size="sm"
                >
                  Associa
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          <div class="form-card-wrapper">
            <b-card header-tag="header">
              <div
                slot="header"
                class="d-flex justify-content-between align-items-center"
              >
                <p class="mb-0 d-inline-block align-middle">
                  <b>Produttore</b>
                </p>
              </div>
              <div class="details-card custom-grid-wrapper">
                <div class="grid-item-label"><strong>Produttori Lisaweb</strong></div>
                <div class="grid-item-value">
                  {{ dbRowData.mappable.attributables?.BUID }} -
                  {{
                    dbRowData.mappable.attributables?.NAME
                      ? dbRowData.mappable.attributables?.NAME +
                      " " +
                      dbRowData.mappable.attributables?.SURN
                      : dbRowData.mappable.attributables?.CNAM
                  }}
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>

      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShowMixin from "@/mixins/ShowMixin";
import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import {mapGetters} from "vuex";
import BaseSelect from "@/components/form/BaseSelect";

export default {
  name: "General",
  mixins: [FormMixin, ShowMixin, ShortcutMixin],
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    BaseSelect,
  },
  data() {
    return {
      repository: "import_map",
      isLoading: false,
      opt_salesmen: [],
      form: {
        mappable_id: null,
        import_map: {
          insurer_id: null,
          broker: {},
          map: null,
        },
      },
      migrate: {},
    };
  },
  methods: {
    onUpdate() {
      this.isLoading = true;
      this.setMandatoryField();
      this.update(this.repository, this.resourceId)
        .then(() => {
          this.$emit("fetch");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    setMandatoryField() {
      this.form[this.repository].insurer_id = this.dbRowData.insurer_id;
      this.form[this.repository].map = this.dbRowData.map;
      this.form[this.repository].broker = {
        [this.form.mappable_id]: {},
      };
    },
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
    }),
  },
  mounted() {
    this.opt_salesmen = this.getSalesmen();
    if (this.canVerb("import_maps", "edit") && this.dbRowData.mappable_id) {
      this.migrate = {
        label: "Migra",
        click: () => {
          this.shortcut(
            "import_maps.transfer",
            this.resourceId,
            null,
            null,
            null,
            null,
            null,
            {details: this.dbRowData}, // mappable_id siccome è il campo "polimorfo", non viene inviato dalla edit: in import_maps.transfer o chiamo la index, o gli passo dbRowData dal router
            this.$options.name
          );
          // this.shortcut(
          //   "import_maps.transfer",
          //   this.resourceId,
          //   null,
          //   null,
          //   null,
          //   {
          //     /* fromShortcut: true */
          //   },
          //   [
          //     {
          //       text: "Configurazione",
          //       path: "",
          //       tab: "",
          //       level: 0,
          //       disabled: true,
          //     },
          //     {
          //       text: "Mappatura Importatori",
          //       path: "module.PROF.CONF",
          //       tab: "",
          //       level: 1,
          //     },
          //     {
          //       text: "Mappatura Produttori",
          //       path: "module.PROF.CONF",
          //       tab: "#Brokers",
          //       level: 2,
          //     },
          //   ],
          //   { details: this.dbRowData }, // mappable_id siccome è il campo "polimorfo", non viene inviato dalla edit: in import_maps.transfer o chiamo la index, o gli passo dbRowData dal router
          //   this.$options.name
          // );
        },
      };
    }
  },
};
</script>
